<template>
    <div class="header-main-search" v-bind:class="{ 'show-results': isAvailable, 'active to-top-animation': isSubmit, 'loading-results': isLoading, }">
        <button type="button" class="close-btn" @click="close">
            <img src="/assets/img/icons/close.svg" width="25" height="25" alt="close" class="inject-me">
            <svg class="show-on-mob" stroke="#fff" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><line stroke-width="4" x1="2" x2="30" y1="2" y2="30"></line><line stroke-width="4" x1="2" x2="30" y1="30" y2="2"></line></svg>
        </button>
        <div class="container container-768 search-container">
            <div class="inner">

                <SearchInput :placeholder="searchInputPlaceholder" :submit="submit"/>

                <img class="loader" src="/assets/img/icons/loader.svg" alt="loader">

                <SearchPagination :available="isAvailable" :searchResultFirst="searchResultFirst" :searchResultSecond="searchResultSecond" :searchResultThird="searchResultThird"/>

            </div>
        </div>
    </div>
</template>

<script>
import SearchInput from './SearchInput.vue';
import SearchPagination from './SearchPagination.vue';
import { mapGetters, mapState, mapMutations } from 'vuex';
import axios from 'axios';

export default {
  components: {
    SearchInput,
    SearchPagination
  },

  data() {
      return {
          isLoading: false,
          isSubmit: false,
          isAvailable: false
      }
  },

  computed: {
    ...mapState(['baseUrl']),
    ...mapGetters(["searchQuery"])
  },

  props: {
    searchInputPlaceholder: { required: true, type: String },
    searchResultFirst: { required: true, type: String },
    searchResultSecond: { required: true, type: String },
    searchResultThird: { required: true, type: String }
  },

  methods: {
      ...mapMutations(['setSearchResult']),

      async submit() {
        this.isLoading = true;
        this.isSubmit = true;
        ga('send', 'event', 'navigation', 'search', 'apply');
        ga('send', 'event', 'navigation', 'search', this.searchQuery);
        var resp = await axios.post(`${this.baseUrl}api/search/find`, {
            searchQuery: this.searchQuery
        })
        .then((resp) => resp.data);

        this.setSearchResult(resp);
        this.isAvailable = true;
        this.isLoading = false;
      },

      close() {
        this.isLoading = false;
        this.isSubmit = false;
        this.isAvailable = false;
      }
  }
}
</script>